import React from 'react';
import OptionsManager from '../../components/Options/OptionsManager';

const OptionManagerPage: React.FC = () => {
    return (
        <div className="option-manager-page">
            <OptionsManager />
        </div>
    );
};

export default OptionManagerPage; 